import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface SpaceGroupExecutePreviewProps {
  member_count?: number;
  name?: string;
}

export const SpaceGroupExecutePreview = ({
  name,
  member_count,
}: SpaceGroupExecutePreviewProps) => {
  const memberCountText =
    member_count != null
      ? t("help_widget.copilot.execute_preview.members_count", {
          count: member_count,
        })
      : undefined;

  return (
    <ExecutePreviewCard
      title={t("help_widget.copilot.execute_preview.space_group_title")}
      attributes={[
        {
          label: t("help_widget.copilot.execute_preview.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.execute_preview.number_of_members"),
          value: memberCountText,
        },
      ]}
    />
  );
};
